export function stringify(s: unknown): string {
  return JSON.stringify(s, (_, value) =>
    typeof value === "bigint" ? value.toString() : value
  )
}
